<kilowant-header [isSeller]="true" title="Sales Agreements"></kilowant-header>
<div class="form seller">
  <div class="card mt-20">
    <div class="body">
      <div class="block-buttons top-card mb-10">
        @if (user!=null) {
          <button type="button" (click)="addSellerContract()">+Add</button>
        }
      </div>
      <table mat-table [dataSource]="dataSource" matSort matSortActive="UtilityName" matSortDirection="asc" matSortDisableClear class="offer-summmary-table">
        <ng-container matColumnDef="#">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let element,let i =index">{{i+1}}</td>
        </ng-container>
        <ng-container matColumnDef="ContractId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
          <td mat-cell *matCellDef="let element"> {{element.id}} </td>
        </ng-container>
        <ng-container matColumnDef="ContractName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>
        <ng-container matColumnDef="ContractHash">
          <th mat-header-cell *matHeaderCellDef>Hash Code</th>
          <td mat-cell *matCellDef="let element"> {{element.hash}} </td>
        </ng-container>
        <ng-container matColumnDef="TermRescission">
          <th mat-header-cell *matHeaderCellDef>Term Rescission</th>
          <td mat-cell *matCellDef="let element"> {{element.termRescission}} </td>
        </ng-container>
        <ng-container matColumnDef="DateAdded">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Added</th>
          <td mat-cell *matCellDef="let element"> {{element.dateEntered | date:'shortDate'}} </td>
        </ng-container>
        <ng-container matColumnDef="DateUpdated">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Updated</th>
          <td mat-cell *matCellDef="let element"> {{element.dateUpdated | date:'shortDate'}} </td>
        </ng-container>
        <ng-container matColumnDef="Action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let element,let i = index">
            <a class="link f18" (click)="editSellerContract(element)">
              <mat-icon class="customIcons">edit_outline</mat-icon>
            </a>
            <a class="link f18" (click)="copySellerContract(element)">
              <mat-icon class="customIcons">content_copy</mat-icon>
            </a>
            @if (element.canBeDeleted) {
              <a class="link f18" (click)="deleteSellerContract(element)">
                <mat-icon class="customIcons">delete_outline</mat-icon>
              </a>
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator [hidePageSize]="true" showFirstLastButtons [pageSize]="RECS_PER_PAGE" aria-label="Select page"></mat-paginator>
    </div>
  </div>
</div>
